import React from 'react';
import {
  Dashboard, Sliders, Users, FileText, Settings
} from '../icons';

const Sidebar = ({ currentView, setCurrentView }) => {
  return (
    <div className="sidebar">
      <div className="logo">
        Collab AI
      </div>

      <div className="nav-section">
        <div 
          className={`nav-item ${currentView === 'dashboard' ? 'active' : ''}`}
          onClick={() => setCurrentView('dashboard')}
        >
          <div className="nav-icon-circle">
            <Dashboard size={20} />
          </div>
          <span>Dashboard</span>
        </div>

        <div 
          className={`nav-item ${currentView === 'routing' ? 'active' : ''}`}
          onClick={() => setCurrentView('routing')}
        >
          <div className="nav-icon-circle">
            <Sliders size={20} />
          </div>
          <span>Routing Rules</span>
        </div>

        <div 
          className={`nav-item ${currentView === 'team' ? 'active' : ''}`}
          onClick={() => setCurrentView('team')}
        >
          <div className="nav-icon-circle">
            <Users size={20} />
          </div>
          <span>Team</span>
        </div>

        <div 
          className={`nav-item ${currentView === 'reports' ? 'active' : ''}`}
          onClick={() => setCurrentView('reports')}
        >
          <div className="nav-icon-circle">
            <FileText size={20} />
          </div>
          <span>Reports</span>
        </div>

        <div 
          className={`nav-item ${currentView === 'settings' ? 'active' : ''}`}
          onClick={() => setCurrentView('settings')}
        >
          <div className="nav-icon-circle">
            <Settings size={20} />
          </div>
          <span>Settings</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;